import React from "react";
import {
  Box,
  Paper,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import styles from "./submissionTable.module.css"; // ✅ Reuse SubmissionTable styles

const EMPTY_STATE_COPY = {
  emptyView: {
    title: "No submissions match this view",
    description:
      "Try widening the date range or clearing search filters.",
  },
  noSubmissions: {
    title: "No submissions yet",
    description:
      "Submitted responses will appear here after the published form receives submissions.",
  },
};

const SubmissionTableZeroState = ({
  variant = "emptyView",
  title = null,
  description = null,
  embedded = false,
}) => {
  const copy = EMPTY_STATE_COPY[variant] || EMPTY_STATE_COPY.emptyView;

  const content = (
    <Box
      sx={{
        minHeight: "320px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.03)", // ✅ Slightly stronger hint for empty state
        borderRadius: "8px", // ✅ Matches tableContainer style
        padding: "32px 20px",
        textAlign: "center",
      }}
    >
      <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
        {title || copy.title}
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          maxWidth: 520,
        }}
      >
        {description || copy.description}
      </Typography>
    </Box>
  );

  if (embedded) {
    return content;
  }

  return (
    <Paper className={styles.tableContainer}>
      {content}
    </Paper>
  );
};

SubmissionTableZeroState.propTypes = {
  variant: PropTypes.oneOf([
    "emptyView",
    "noSubmissions",
  ]),
  title: PropTypes.string,
  description: PropTypes.string,
  embedded: PropTypes.bool,
};

export default SubmissionTableZeroState;
